import { render, staticRenderFns } from "./EPointWithdrawDialog.vue?vue&type=template&id=1dbdc0c8&"
import script from "./EPointWithdrawDialog.vue?vue&type=script&lang=js&"
export * from "./EPointWithdrawDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QToolbar,QToolbarTitle,QSeparator,QCardSection,QInput,QChip,QIcon,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QToolbar,QToolbarTitle,QSeparator,QCardSection,QInput,QChip,QIcon,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
